import { Bot, Sparkles, User } from "lucide-react";

interface OriginBadgeProps {
  origin: string | null | undefined;
  actorSource: string | null | undefined;
  model?: string | null;
}

export function OriginBadge({ origin, actorSource, model }: OriginBadgeProps) {
  if (!origin) return null;

  if (origin === "system") {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-purple-50 px-2 py-0.5 text-[10px] font-medium text-purple-700 dark:bg-purple-900/20 dark:text-purple-300">
        <Sparkles className="h-3 w-3" />
        AI generated{model ? ` (${model})` : ""}
      </span>
    );
  }

  if (origin === "user" && actorSource === "ai_agent") {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-[10px] font-medium text-blue-700 dark:bg-blue-900/20 dark:text-blue-300">
        <Bot className="h-3 w-3" />
        Edited via assistant
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-400">
      <User className="h-3 w-3" />
      Edited manually
    </span>
  );
}
